import Vue from 'vue'
import Vuex from 'vuex'
import app from '../state/modules/app'
import auth from '../state/modules/auth'
import companies from '../state/modules/companies'
import demoCreator from '../state/modules/demoCreator'
import devices from '../state/modules/devices'
import deviceGroups from '../state/modules/deviceGroups'
import deviceProfiles from '../state/modules/deviceProfiles'
import keys from '../state/modules/keys'
import measuringPoints from '../state/modules/measuringPoints'
import orders from '../state/modules/orders'
import profile from '../state/modules/profile'
import reports from '../state/modules/reports'
import subscriptions from '../state/modules/subscriptions'
import tours from '../state/modules/tours'
import tablets from '../state/modules/tablets'
import users from '../state/modules/users'
import asyncTasksTracker from "./modules/asyncTasksTracker";
import bootPlugin from './plugins/boot.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    auth,
    asyncTasksTracker,
    companies,
    demoCreator,
    devices,
    deviceGroups,
    deviceProfiles,
    keys,
    measuringPoints,
    orders,
    profile,
    reports,
    subscriptions,
    tours,
    tablets,
    users
  },
  plugins: [bootPlugin],
  strict: process.env.NODE_ENV !== 'production',
})
